var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {callApi} from "../api";
export function getUsersList(offset, limit, column, order, filter) {
  return __async(this, null, function* () {
    var _a, _b;
    const orderShort = !!order ? order === "ascend" ? "ASC" : "DESC" : "";
    const queryString = `?offset=${offset}&limit=${limit}${column ? `&sort=${column}` : ""}${orderShort ? `&order=${orderShort}` : ""}${filter ? `&filter=${encodeURIComponent(filter.trim())}` : ""}`;
    const r = yield callApi("/admin/users" + queryString, {method: "GET"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getUser(id) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/admin/users/${id}`, {method: "GET"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function inviteUser(email, isExpert = false, channelId, partnerId) {
  return __async(this, null, function* () {
    var _a, _b;
    const body = email ? {email, is_expert: isExpert, channel_id: channelId, partner_id: partnerId} : {is_expert: isExpert, channel_id: channelId, partner_id: partnerId};
    const r = yield callApi("/admin/users/invites", {
      method: "POST",
      body
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function upgradeUser(userId, channelId) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/admin/users/${userId}/upgrade`, {
      method: "POST",
      body: {channel_id: channelId}
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getChannels() {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi(`/admin/channels/`, {method: "GET"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getInvitesList(offset, limit) {
  return __async(this, null, function* () {
    var _a, _b;
    const queryString = `?offset=${offset}&limit=${limit}`;
    const r = yield callApi("/admin/users/invites" + queryString, {method: "GET"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getCallsList(offset, limit, column, order, filter, status) {
  return __async(this, null, function* () {
    var _a, _b;
    const orderShort = !!order ? order === "ascend" ? "ASC" : "DESC" : "";
    const queryString = `?offset=${offset}&limit=${limit}${column ? `&sort=${column}` : ""}${orderShort ? `&order=${orderShort}` : ""}${filter ? `&filter=${filter}` : ""}${status ? `&status=${status}` : ""}`;
    const r = yield callApi("/admin/users/calls" + queryString, {method: "GET"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function getIncompleteProfilesList(offset, limit, sortBy, order, filter) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi("/admin/incomplete-profiles", {
      method: "POST",
      body: {
        offset,
        limit,
        sortBy,
        order: !!order ? order === "ascend" ? "ASC" : "DESC" : void 0,
        filter
      }
    });
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
export function fetchInvite(invitecode) {
  return __async(this, null, function* () {
    var _a, _b;
    const r = yield callApi("/admin/users/invites/" + invitecode, {method: "GET"});
    if (!r.ok)
      throw Error((_b = (_a = r.payload) == null ? void 0 : _a.data) == null ? void 0 : _b.message);
    return r.payload.data;
  });
}
